module.exports = __webpack_public_path__ + "img/20190705162937584.5bc31956.png";